const filters = {
  date(value) {
    try {
      if (!value) return '';
      // Nykredit compact format YYYYMMDD → DD-MM-YYYY
      if (/^\d{8}$/.test(value)) {
        return `${value.slice(6, 8)}-${value.slice(4, 6)}-${value.slice(0, 4)}`;
      }
      if (isNaN(Date.parse(value))) {
        return value.split('-').reverse().join('-');
      } else {
        let time = new Date(value);
        const t = time.toISOString().slice(0, 10).split('-').reverse().join('-')
        return t;
      }
    } catch (error) {
      console.error('Error in date filter:', error);
      return '';
    }
  },
  round(value, digits) {
    return Math.round(parseFloat(value) * 10 ** digits) / 10 ** digits;
  },
  percentage(value, opts = {}) {
    if (!value && value != 0) { return ''; }
    return value.toLocaleString('da-dk', Object.assign(opts, { style: 'percent' }));
  },
  percentageNoZero(value, opts = {}) {
    if (!value || (value && value.round(10) == 0)) { return ''; }
    return value.toLocaleString('da-dk', Object.assign(opts, { style: 'percent' }));
  },
  localized(value, opts = {}) {
    if (!value && value != 0) { return ''; }
    return value.toLocaleString('da-dk', opts);
  },
  localizedNoZero(value, opts = {}) {
    if (!value || (value && value.round(10) == 0)) { return ''; }
    return value.toLocaleString('da-dk', opts);
  },
  datetime(value) {
    if (!value) { return ''; }
    let time = new Date(value);
    return `${time.toISOString().slice(0, 10).split('-').reverse().join('\u2011')}\u00A0${time.toLocaleTimeString().split('-').join('\u2011')}`;
  },
  byte(value) {
    if (!value) { return '0B'; }
    if (value <= 1024) {
      return value + 'B';
    } else if (value <= 1024 ** 2) {
      return Math.ceil(value / 1024 ** 1) + 'kB';
    } else if (value <= 1024 ** 3) {
      return Math.round((value / 1024 ** 2) * 100) / 100 + 'MB';
    } else if (value <= 1024 ** 4) {
      return Math.round((value / 1024 ** 3) * 100) / 100 + 'GB';
    } else if (value <= 1024 ** 5) {
      return Math.round((value / 1024 ** 4) * 100) / 100 + 'TB';
    } else if (value <= 1024 ** 7) {
      return Math.round((value / 1024 ** 5) * 100) / 100 + 'PB';
    } else {
      return Math.round((value / 1024 ** 6) * 100) / 100 + 'EB';
    }
  }
};

export default filters;
